export default __webpack_public_path__ + "static/media/crm_photo.c02e96e5.svg";